import React from 'react';
import { Checkbox } from '@vtblife/uikit';
import { OptionType } from '@vtblife/uikit/legacy';

import { PrepaymentType } from '@search/filter-enums/enums/PrepaymentType';
import { RentPrepaymentFilter } from '../../../../models/Filter';

interface IPrePaymentButtonFilter {
    filter: RentPrepaymentFilter;
    handleChange: (filter: RentPrepaymentFilter) => void;
    classNameGroup?: string;
}

const OPTIONS_TYPE: OptionType<PrepaymentType>[] = [
    { label: 'Без предоплаты', value: PrepaymentType.NO_PREPAYMENT },
    { label: '1 месяц', value: PrepaymentType.UP_TO_1_PRICE },
    { label: '2 месяца', value: PrepaymentType.UP_TO_2_PRICE },
    { label: '3 месяца', value: PrepaymentType.UP_TO_3_PRICE },
];

export const PrePaymentButtonFilterView: React.FC<IPrePaymentButtonFilter> = ({
    filter,
    handleChange,
    classNameGroup
}) => {
    const onChange = React.useCallback((value: boolean, option: PrepaymentType) => {
        if (value) handleChange(new RentPrepaymentFilter(option));
        else handleChange(new RentPrepaymentFilter());
    }, [ handleChange ]);

    return (
        <div className={classNameGroup}>
            {OPTIONS_TYPE.map(type => (
                <div key={type.value} style={{ width: 'max-content' }}>
                    <Checkbox
                        name={type.label}
                        value={filter.prePaymentType === type.value}
                        onChange={value => onChange(value, type.value)}
                        variant='filter'
                        block
                    >
                        {type.label}
                    </Checkbox>
                </div>
            ))}
        </div>
    );
};
